import './CopyLink.module.css';

import {
  Button,
  Input,
  Tooltip,
  tooltipPlacements,
  CopyLinkIcon,
  IconThumbnailButton
} from '@animoto/components/lib/es/design-system';
import React, { useEffect, useState } from 'react';
import { noop } from 'lodash';
import { trackEvent } from '@animoto/utils/analytics';
import PropTypes from 'prop-types';
import { copyToClipboard } from '../../../../utils/copyToClipboard';
import trackShare from '../../../../utils/trackShare';

export default function CopyLink({
  pageName,
  resolution,
  showInput,
  url
}) {
  const [tooltipTimeoutId, setTooltipTimeoutId] = useState(null);

  function onCopyLink() {
    trackShare('share', 'link', resolution, `link-button_clicked:${pageName}`);

    copyToClipboard(url);

    if (tooltipTimeoutId) {
      clearTimeout(tooltipTimeoutId);
    }

    const timeoutId = setTimeout(() => {
      setTooltipTimeoutId(null);
    }, 1000);
    setTooltipTimeoutId(timeoutId);
  }

  useEffect(() => {
    if (showInput) {
      trackEvent(pageName, 'dialog-LinkView');
    }
  }, [pageName, showInput]);

  useEffect(() => () => {
    if (tooltipTimeoutId) {
      clearTimeout(tooltipTimeoutId);
    }
  }, [tooltipTimeoutId]);

  return (
    <>
      {showInput && (
        <Input label="" name="copy" onChange={noop} value={url} />
      )}
      <Tooltip isVisible={!!tooltipTimeoutId} overlayText="Link copied!" placement={tooltipPlacements.TOP}>
        {!showInput ? (
          <IconThumbnailButton
            icon={<CopyLinkIcon />}
            onClick={onCopyLink}
          >
            Copy Link
          </IconThumbnailButton>
        ) : (
          <Button icon={<CopyLinkIcon />} onClick={onCopyLink} styleName="copy-button">Copy Link</Button>
        )}
      </Tooltip>
    </>
  );
}

CopyLink.propTypes = {
  pageName   : PropTypes.string.isRequired,
  resolution : PropTypes.string.isRequired,
  showInput  : PropTypes.bool.isRequired,
  url        : PropTypes.string.isRequired
};
